import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

import { CAMPAIGNS_ROUTES } from '#modules/campaigns/routes/logged-in-campaigns.routing';
import { REVIEWS_ROUTES } from '#modules/reviews/routes/reviews.routing';

export const REPUTATION_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/restaurants/reputation-layout/reputation-layout.component').then(
                (m) => m.ReputationLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'reviews',
            },
            {
                path: 'reviews',
                loadChildren: () => REVIEWS_ROUTES,
                data: { routePath: RoutePath.REVIEWS },
            },
            {
                path: 'campaigns',
                loadChildren: () => CAMPAIGNS_ROUTES,
                data: { routePath: RoutePath.REVIEW_CAMPAIGNS },
            },
        ],
    },
];
